/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_Marker_CommentsInputs */



/**
* | output |
* | --- |
* | "Show Marker Comments" |
*
* @param {Options_Editor_Show_Marker_CommentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_marker_comments = /** @type {((inputs?: Options_Editor_Show_Marker_CommentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_Marker_CommentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les commentaires des marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Marker-Kommentare anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra commenti del marcatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать комментарии к маркеру")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar comentarios del marcador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示标记评论")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーコメントを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर टिप्पणियाँ दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar comentários do marcador")
	return /** @type {LocalizedString} */ ("Show Marker Comments")
});